import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';
import { IconBorderHorizontal } from '@tabler/icons-react';

/**
 * Used to insert a horizontal line into the editor.
 */
export default function InsertHorizontalLine({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      icon={<IconBorderHorizontal />}
      label="Vodorovná čiara"
      onClick={() => editor?.chain().focus().setHorizontalRule().run()}
    />
  );
}
